import { CheckboxField } from '@ps-design-system/components/Checkbox';
import { Form } from '@ps-design-system/components/Form';
import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useCheckoutContext } from '../../CheckoutContextProvider';

export const SocialEventPolicyForm = ({ urlPrefix }) => {
  const { socialEventPolicyForm, isSubmittingRequest } = useCheckoutContext();

  return (
    <Form testId="social-event-policy-form" {...socialEventPolicyForm}>
      <div
        style={{
          marginTop: '24px',
          padding: '24px',
          backgroundColor: '#F8F9FA',
          border: '1px solid #E9EBEF',
          borderRadius: '4px'
        }}
      >
        <CheckboxField
          testId="social-event-policy-checkbox"
          alignment="top"
          name="socialEventPolicyAccepted"
          disabled={isSubmittingRequest}
          description={
            <span style={{ textTransform: 'none' }}>
              <FormattedMessage
                id="inbox_review_offer.social_event_policy_checkbox.accept_policy"
                defaultMessage="I agree to the {agreement}, and acknowledge that I am liable for any incidents or damages resulting from the actions of any attendees. I understand my booking may be cancelled if I do not provide proof of insurance upon request."
                values={{
                  agreement: (
                    <Text
                      element="a"
                      typeface="body-2-m"
                      style={{ textDecoration: 'underline' }}
                      href={`https://www.peerspace.com${urlPrefix}/legal/terms`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FormattedMessage
                        id="inbox_review_offer.social_event_policy_checkbox.peerspace_agreement"
                        defaultMessage="Peerspace Services Agreement"
                      />
                    </Text>
                  )
                }}
              />
            </span>
          }
        />
      </div>
    </Form>
  );
};

SocialEventPolicyForm.displayName = 'SocialEventPolicyForm';
SocialEventPolicyForm.propTypes = {
  urlPrefix: PropTypes.string
};
